import React, { useEffect, useRef, useState } from "react";
import ClientLayoutWithOutHeader from "../../client/components/layout/ClientLayoutWithOutHeaderForTeenPatti";
import TpStudioHeader from "../../client/tp-studio/tp-studio-header";
import TPStudioSidebar from "../../client/tp-studio/TPStudioSidebar";
import reconnecting from "../../../assets/topstudio/images/rolet/reconnecting.gif";
import "../../../assets/topstudio/styles/Player.css";
import useSocket from "../../../hooks/useSocket";
import useClosedPhaseOverlay from "../../../hooks/useClosedPhaseOverlay";
import TeenPattisCasinoBetslipWeb from "./teenpatti_casino_betslip_web";
import axiosInstance from "../../../utils/axiosInstance";
import TpStudioLoader from "../../client/tp-studio/tp-studio-loader";
import Volume from "./Volume";
import Race17Result from "../../client/tp-studio/tp-result/Race17Result";
import TPPopUpBetSlip from "./teenpatti_casino_betslip_popup.jsx";
import { isMobile } from "react-device-detect";
import RaceRules from "./pop-up/race17-rules.jsx";

import { useDispatch, useSelector } from "react-redux";
import { setUserData } from "../../../store/userSlice";

export default function Race17() {
  const dispatch = useDispatch();
  const [stakeLimit, setStakeLimit] = useState(0);
  const [showRules, setShowRules] = useState(false);
  const [showBetSlipPopup, setShowBetSlipPopup] = useState(false);
  const [showBetSlip, setShowBetSlip] = useState(false);
  const [placeBetObject, setPlaceBetObject] = useState({});
  const [betErrorMessageObj, setBetErrorMessage] = useState({});
  const [open, setOpen] = useState(false);

  const [betButtonShow, setBetButtonShow] = useState(true);
  const [betButtonShowLoaderShow, setButtonShowLoaderShow] = useState(false);

  const [b1, setB1Odd] = useState("");
  const [l1, setl1Odd] = useState("");
  const [b2, setB2Odd] = useState("");
  const [l2, setl2Odd] = useState("");
  const [totalScore, setTotalScore] = useState(0);

  const [RaceTo17PL1, setRaceTo17PL1] = useState(0);
  const [RaceTo17PL2, setRaceTo17PL2] = useState(0);

  const [AnyZeroCardPL1, setAnyZeroCardPL1] = useState(0);
  const [AnyZeroCardPL2, setAnyZeroCardPL2] = useState(0);

  const [raceTo17Suspend, setRaceTo17Suspend] = useState("1");
  const [anyZeroCardSuspend, setAnyZeroCardSuspend] = useState("1");

  const [raceTo17Winner, setRaceTo17Winner] = useState(0);
  const [isAnyZeroWinner, setIsAnyZeroWinner] = useState(0);

  const [roundId, setRoundId] = useState(0);
  const [cardDesc, setCardDesc] = useState([]);
  const [resultDesc, setResultDesc] = useState("");
  const [result, setResult] = useState("");
  const [resultList, setResultList] = useState([]);
  const [lastStatus, setLastStatus] = useState(null);
  const [activeTabIndex, setActiveTabIndex] = useState(1);

  /* ================= TIMER ================= */
  const TOTAL_SECONDS = 30;
  const [timeLeft, setTimeLeft] = useState(TOTAL_SECONDS);
  const localTimerRef = useRef(null);
  const [resultData, setResultData] = useState([]);

  const sessionUser = useSelector((s) => s.userStore.data);
  const updateUserData = async (userData) => {
    if (!userData || !sessionUser) return;
    await dispatch(
      setUserData({
        ...sessionUser,
        fname: userData.fname ?? sessionUser.fname,
        uname: userData.uname ?? sessionUser.uname,
        bz_balance: userData.bz_balance ?? sessionUser.bz_balance,
        opin_bal: userData.opin_bal ?? sessionUser.opin_bal,
        user_role: sessionUser.user_role,
        _id: sessionUser._id
      })
    );
  };

  /* ================= SINGLE CARD STATE ================= */
  const [shownCard, setShownCard] = useState("1");
  const [shouldFlip, setShouldFlip] = useState(false);
  const lastEvtStatusRef = useRef(null);
  const flipTimerRef = useRef(null);
  const cardsSettleTimerRef = useRef(null);
  const [shownCardDescs, setShownCardDescs] = useState([]);
  const [cardsSettled, setCardsSettled] = useState(false);

  const [displayLoader, setDisplayLoader] = useState(true);
  /* ================= SOCKET ================= */
  const { data } = useSocket({
    marketId: null,
    mtype: "teenpatti",
    type: "race17_virtual"
  });

  const payload = data?.data?.data;
  const { isSuspended, suspendedText } = useClosedPhaseOverlay(
    payload?.evt_status,
    payload?.cat_mid,
    setShowBetSlipPopup
  );
  //console.log("data:", payload); // DO NOT REMOVE

  const payloadResult = data?.data?.result;
  //console.log("payloadResult:", payloadResult); // DO NOT REMOVE
  /* ================= TIMER + VALUES ================= */
  useEffect(() => {
    if (!payload) return;
    setDisplayLoader(false);
    updateUserData(data?.user);

    if (lastStatus !== payload.evt_status && payload.evt_status === "OPEN") {
      setPlacedBets([]);
      setRaceTo17PL1(0);
      setRaceTo17PL2(0);
      setAnyZeroCardPL1(0);
      setAnyZeroCardPL2(0);
      setTotalScore(0);
      setCardDesc([]);
      setCardsSettled(false);
      clearTimeout(cardsSettleTimerRef.current);
    }

    if (lastStatus !== payload.evt_status) {
      setLastStatus(payload.evt_status);
    }

    setRoundId(payload?.cat_mid);

    setB1Odd(payload?.b1);
    setl1Odd(payload?.l1);

    setB2Odd(payload?.b2);
    setl2Odd(payload?.l2);

    setTotalScore(payload?.resultTotal);
    setIsAnyZeroWinner(payload?.is_any_zero);
    setRaceTo17Winner(payload?.result);

    setRaceTo17Suspend(payload?.suspend1);
    setAnyZeroCardSuspend(payload?.suspend2);

    setResultDesc(payload?.result_desc);

    if (payload?.cards_desc !== "") {
      let desc = payload?.cards_desc.split(",");
      setCardDesc(desc);
    } else {
      setCardDesc([]);
    }

    const serverSeconds = payload?.left_time;
    if (typeof serverSeconds === "number") {
      setTimeLeft(serverSeconds);
    }

    clearInterval(localTimerRef.current);
    localTimerRef.current = setInterval(() => {
      setTimeLeft((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
  }, [payload]);

  useEffect(() => {
    if (!payloadResult) return;

    if (payloadResult !== "") {
      //console.log("payloadResult->", payloadResult);
      setResultList([]);
      setResultList(payloadResult);
    }
  }, [payloadResult]);

  useEffect(() => () => clearInterval(localTimerRef.current), []);
  useEffect(
    () => () => {
      clearTimeout(flipTimerRef.current);
      clearTimeout(cardsSettleTimerRef.current);
    },
    []
  );

  /* ================= SEQUENTIAL CARD REVEAL ================= */
  useEffect(() => {
    if (!payload?.evt_status) return;
    if (lastEvtStatusRef.current === payload.evt_status) return;

    lastEvtStatusRef.current = payload.evt_status;
    clearTimeout(flipTimerRef.current);

    if (payload.evt_status === "OPEN") {
      setShownCardDescs([]);
      setShouldFlip(false);
      setCardsSettled(false);
      clearTimeout(cardsSettleTimerRef.current);
      return;
    }

    if (payload.evt_status === "CLOSED") {
      setShouldFlip(true);

      const cards =
        payload?.cards_desc && payload.cards_desc !== ""
          ? payload.cards_desc.split(",")
          : [];

      if (cards.length === 0) return;

      setShownCardDescs([]);
      let index = 0;

      function revealNext() {
        index++;
        setShownCardDescs(cards.slice(0, index));
        if (index < cards.length) {
          flipTimerRef.current = setTimeout(revealNext, 1000);
        }
      }

      flipTimerRef.current = setTimeout(revealNext, 300);
    }

    return () => clearTimeout(flipTimerRef.current);
  }, [payload?.evt_status]);

  useEffect(() => {
    const totalCards = cardDesc.length;
    const allRevealed = totalCards > 0 && shownCardDescs.length >= totalCards;

    if (!allRevealed) {
      setCardsSettled(false);
      clearTimeout(cardsSettleTimerRef.current);
      return;
    }

    clearTimeout(cardsSettleTimerRef.current);
    cardsSettleTimerRef.current = setTimeout(() => {
      setCardsSettled(true);
    }, 1000);

    return () => clearTimeout(cardsSettleTimerRef.current);
  }, [shownCardDescs, cardDesc]);

  /* ================= SVG TIMER ================= */
  const R = 45;
  const CIRC = 2 * Math.PI * R;
  const dash = Math.max(0.0001, CIRC * (timeLeft / TOTAL_SECONDS));
  const timerColor =
    timeLeft <= 5 ? "red" : timeLeft <= 10 ? "orange" : "green";

  /* ================= BET SLIP ================= */
  const showBetfairBetSlip = (
    bettype,
    teamname,
    selectRnr,
    price,
    marketTypeVal,
    sid,
    marketVal
  ) => {
    let obj = {
      amount: 0,
      catmid: payload?.cat_mid,
      round: payload?.cat_mid,
      odds: price,
      teamname,
      bettype,
      selectRnr,
      marketVal: marketVal,
      game_type: 7,
      game_name: "race17_virtual",
      market_type: marketTypeVal,
      sid: sid
    };

    setPlaceBetObject(obj);
    if (isMobile) {
      setShowBetSlipPopup(true);
    } else {
      setShowBetSlip(true);
    }
  };

  const closeBetSlipMobile = () => {
    setShowBetSlipPopup(false);
    setBetErrorMessage({});
  };

  const closeBetSlip = () => setShowBetSlip(false);

  const [profileData, setProfileData] = useState(null);
  const [placedBets, setPlacedBets] = useState([]);
  const [initialBetsFetched, setInitialBetsFetched] = useState(false);

  const fetchProfile = async () => {
    const { data } = await axiosInstance.get("/profile");
    setProfileData(data);
  };

  const betStakeLimit = async () => {
    try {
      const { data } = await axiosInstance.get("/profile/bet-stake-limit");
      if (data != null && data !== undefined) {
        let limit = data?.myBetLimit?.teenpatiStudio;
        setStakeLimit(formatTruncate(limit));
      }
    } catch (error) {
      console.log("Failed to load profile data:", error);
    }
  };

  const activeTab = async (tab1) => {
    setActiveTabIndex(tab1);
    if (tab1 == 2) {
      showResultDetail();
    }
  };

  async function getPlacedBets() {
    if (!payload?.cat_mid) return;
    const res = await axiosInstance.post("/casino/get-placed-bets", {
      cat_mid: payload.cat_mid,
      gametype: "race17_virtual"
    });

    setPlacedBets(res.data);
  }

  async function getBook() {
    if (!payload?.cat_mid) return;
    const res = await axiosInstance.post("/casino/get-book", {
      cat_mid: payload.cat_mid,
      gametype: "race17_virtual"
    });

    setRaceTo17PL1(res.data?.RaceTo17PL?.back);
    setRaceTo17PL2(res.data?.RaceTo17PL?.lay);
    setAnyZeroCardPL1(res.data?.AnyZeroCardPL?.back);
    setAnyZeroCardPL2(res.data?.AnyZeroCardPL?.lay);
  }

  useEffect(() => {
    fetchProfile();
    betStakeLimit();
  }, []);

  useEffect(() => {
    if (!initialBetsFetched && payload?.cat_mid) {
      getPlacedBets();
      getBook();
      setInitialBetsFetched(true);
    }
  }, [payload]);

  const placeBet = async (amount, profit) => {
    placeBetObject.amount = amount;
    placeBetObject.profit = profit;
    // placeBetObject.sid1 = payload?.sid1;
    // placeBetObject.sid2 = payload?.sid2;
    // placeBetObject.sid3 = payload?.sid3;

    try {
      const response = await axiosInstance.post(
        "/casino/place-bet-casino",
        placeBetObject
      );

      if (
        response.data !== undefined &&
        response.data !== null &&
        response.data.status !== undefined &&
        response.data.status !== null
      ) {
        let messageObj = {};
        if (response.data.status) {
          messageObj.status = true;
          setShowBetSlipPopup(false);
          getPlacedBets();
          getBook();
        } else {
          messageObj.status = false;
        }
        messageObj.message = response.data.message;
        setBetErrorMessage(messageObj);
      }
    } catch (error) {
      if (error.response.data !== undefined && error.response.data !== null) {
        if (
          error.response.data.status !== undefined &&
          error.response.data.status !== null &&
          error.response.data.status === false
        ) {
          let errorMessage = error.response.data.message;
          let messageObj = {};
          messageObj.status = false;
          messageObj.message = errorMessage;
          setBetErrorMessage(messageObj);
        }
      }
    }
  };

  const displayRunnerName = (runnerName) => {
    return runnerName
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  const getResultDisplayName = (value) => {
    let returnTxt = "";
    if (value === 1) {
      returnTxt = "Y";
    } else if (value === 2) {
      returnTxt = "N";
    }
    return returnTxt;
  };

  /// result detail ///
  const showResultDetail = async () => {
    let resultObj = {};
    resultObj.game_type = "race17_virtual";

    const response = await axiosInstance.post("/teenpatti-results", resultObj);

    setResultData(response.data.results_list);
    //console.log("response->", resultData);
  };
  /// result detail ///

  const formatTruncate = (value) => {
    let num = Math.round(value);
    const truncated = Math.floor(num * 1000) / 1000;

    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3
    }).format(truncated);
  };

  //console.log("resultList:", resultList);
  //console.log("roundId:", roundId);

  return (
    <div className="teenpatti-scope aviator-scope player-scope aviator-bg-black">
      <ClientLayoutWithOutHeader showLoader={false}>
        <div class="details-tabs-wrapper1">
          <div className="main-page">
            <div className="row no-gutters">
              <div className="col-md-12">
                <div className="bodyheight">
                  <div className="wrapper">
                    <TPStudioSidebar open={open} />
                  </div>

                  <div className="lobby-ctn BPGmaindiv">
                    <TpStudioHeader setOpen={setOpen} open={open} />
                    <TpStudioLoader displayLoader={displayLoader} />
                  </div>

                  <div
                    className="row"
                    style={{ display: displayLoader ? "none" : "" }}
                  >
                    <div className="col-md-8">
                      <div className="left-content">
                        <div>
                          <div className="footer-divbpg border-gradient-footer border-gradient-purple-footer h-45">
                            <div className="col-6 col-md-6 titlebarname  inline-block Gameidcol mt-2">
                              <p>RACE TO 17</p>
                            </div>
                            <div
                              className="col-6 col-md-6 inline-block Gameidcol text-center"
                              style={{ marginTop: "4px" }}
                            >
                              <div
                                role="group"
                                aria-label="Second group"
                                class="btn-group btn-group-sm mr-2"
                                style={{ float: "right" }}
                              >
                                <button
                                  style={{
                                    fontSize: "14px",
                                    display: "inline-block"
                                  }}
                                  type="button"
                                  className={
                                    activeTabIndex == 1
                                      ? "tablink btn btn-primary bbactive"
                                      : "tablink btn btn-primary"
                                  }
                                  onClick={() => activeTab(1)}
                                >
                                  Game
                                </button>
                                <button
                                  style={{
                                    fontSize: "14px",
                                    display: "inline-block"
                                  }}
                                  type="button"
                                  className={
                                    activeTabIndex == 2
                                      ? "tablink btn btn-primary bbactive"
                                      : "tablink btn btn-primary"
                                  }
                                  onClick={() => activeTab(2)}
                                >
                                  Results
                                </button>
                                <button
                                  style={{
                                    fontSize: "14px",
                                    display: "inline-block"
                                  }}
                                  type="button"
                                  class="tablink btn btn-primary "
                                  data-toggle="modal"
                                  data-target="#rulesPopup"
                                  onClick={() => setShowRules(true)}
                                >
                                  Rules
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="cards-layout blackjack"
                          style={{
                            display: activeTabIndex == 1 ? "" : "none"
                          }}
                        >
                          <div>
                            <div className="cards-layout blackjack">
                              <div
                                className="col-12 timerDiv2"
                                style={{ paddingLeft: "0px" }}
                              >
                                <RaceRules
                                  show={showRules}
                                  onClose={() => setShowRules(false)}
                                />
                              </div>

                              <span style={{ opacity: 1 }}>
                                <span
                                  id="AlltabData"
                                  style={{
                                    display: activeTabIndex == 1 ? "" : "none"
                                  }}
                                >
                                  <div
                                    id="videos"
                                    class="collapse show race17-gradient"
                                    aria-labelledby="headingThree"
                                    data-parent="#video"
                                    style={{
                                      textAlign: "center",
                                      padding: "0px",
                                      border: "solid 1px #130a21",
                                      minHeight: "185px",
                                      position: "relative"
                                    }}
                                  >
                                    <div className="race17-timer-row">
                                      <div className="Connectedclients mt-1">
                                        <i
                                          aria-hidden="true"
                                          className="fa fa-user mr-1"
                                          style={{
                                            fontSize: "14px",
                                            color: "white"
                                          }}
                                        />
                                        <b>
                                          <span
                                            id="UsersCount"
                                            className="number"
                                          >
                                            326
                                          </span>
                                        </b>
                                      </div>
                                      <div className="teenpatti-base-timer">
                                        <svg
                                          viewBox="0 0 100 100"
                                          className="base-timer__svg"
                                        >
                                          <g className="base-timer__circle">
                                            <circle
                                              cx="50"
                                              cy="50"
                                              r="45"
                                              className="base-timer__path-elapsed"
                                            />
                                            <path
                                              strokeDasharray={`${Math.round(
                                                dash
                                              )} ${Math.round(CIRC)}`}
                                              className={`base-timer__path-remaining ${timerColor}`}
                                              d="
                                                M 50, 50
                                                m -45, 0
                                                a 45,45 0 1,0 90,0
                                                a 45,45 0 1,0 -90,0
                                              "
                                            />
                                          </g>
                                        </svg>
                                        <span className="base-timer__label">
                                          {timeLeft == 1 ? 0 : timeLeft}
                                        </span>
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div class="col-md-12">
                                        <div class="row">
                                          <div class="player">
                                            <div class="player-item">
                                              <span class="name">
                                                {totalScore != ""
                                                  ? totalScore
                                                  : "Total Score"}
                                              </span>
                                              <div
                                                class="player-card  stood"
                                                style={{
                                                  marginLeft: "15px",
                                                  marginRight: "15px"
                                                }}
                                              >
                                                <div class="header-title">
                                                  <span class="status"></span>
                                                </div>
                                                <div
                                                  id="BFBCardHandView"
                                                  class="BFBCardHandView"
                                                >
                                                  <div
                                                    id="game-cards1"
                                                    class="BFBCardFanView"
                                                  >
                                                    {" "}
                                                    {shownCardDescs.map(
                                                      (key, i) => (
                                                        <div
                                                          class="card1"
                                                          key={i}
                                                        >
                                                          <img
                                                            src={`../assets/galaxy/img/cards3/${key}.svg`}
                                                            class="RSMImageView animate__animated animate__flipInY"
                                                          />
                                                        </div>
                                                      )
                                                    )}
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    <Volume
                                      id="Race17Soundcontrol"
                                      style={{
                                        position: "absolute",
                                        right: 23,
                                        bottom: -7,
                                        zIndex: 100
                                      }}
                                    />
                                  </div>
                                  {/* footer */}
                                  <div
                                    className="footer-divbpg border-gradient-footer border-gradient-purple-footer"
                                    style={{ height: "40px" }}
                                  >
                                    <div className="buttons-div">
                                      {Object.keys(resultList).map((key) => (
                                        <button className="video-button border-gradient-btn border-gradient-purple-btn">
                                          {" "}
                                          {getResultDisplayName(
                                            resultList[key]
                                          )}
                                        </button>
                                      ))}
                                    </div>
                                    <div class="round-div">
                                      <div class="label">Round ID:</div>{" "}
                                      <div id="round-id">{roundId}</div>
                                    </div>
                                  </div>
                                </span>
                              </span>

                              <div
                                class="tb-content space"
                                style={{
                                  background: "#fff"
                                }}
                              >
                                <div class="market-titlebar">
                                  <p class="market-name">
                                    <span class="market-name-badge">
                                      <i class="market-name-icon">
                                        <img
                                          src="/assets/images/time-img.png"
                                          style={{
                                            filter: "invert(100%)",
                                            marginTop: "-8px",
                                            marginLeft: "-1px"
                                          }}
                                        />
                                      </i>
                                      <span>MAIN </span>
                                    </span>
                                  </p>
                                  <div class="market-overarround">
                                    <span></span>
                                    <strong>Back</strong>
                                  </div>
                                  <div class="market-overarround market-overarround-lay">
                                    <strong>Lay</strong>
                                  </div>
                                </div>

                                <div class="market-runners">
                                  <div
                                    class={
                                      raceTo17Winner == 1 && cardsSettled
                                        ? "runner-runner sussesBg"
                                        : "runner-runner"
                                    }
                                  >
                                    <h3 class="runner-name" id="b1Sucess">
                                      <div class="runner-info">
                                        <span class="clippable runner-display-name">
                                          <table>
                                            <tbody>
                                              <tr>
                                                <td>
                                                  <h4
                                                    style={{
                                                      marginBottom: "0px",
                                                      fontSize: "16px",
                                                      fontWeight: "700"
                                                    }}
                                                    class="clippable-spacer"
                                                  >
                                                    Race To 17
                                                  </h4>
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>
                                                  <div
                                                    style={{
                                                      float: "left"
                                                    }}
                                                  >
                                                    <span
                                                      style={{
                                                        display:
                                                          RaceTo17PL1 != 0
                                                            ? ""
                                                            : "none",
                                                        color:
                                                          RaceTo17PL1 > 0
                                                            ? "green"
                                                            : "red"
                                                      }}
                                                    >
                                                      {RaceTo17PL1 != 0
                                                        ? formatTruncate(
                                                            RaceTo17PL1
                                                          ) + "/"
                                                        : " "}{" "}
                                                    </span>

                                                    <span
                                                      style={{
                                                        display:
                                                          RaceTo17PL2 != 0
                                                            ? ""
                                                            : "none",
                                                        color:
                                                          RaceTo17PL2 > 0
                                                            ? "green"
                                                            : "red"
                                                      }}
                                                    >
                                                      {RaceTo17PL2 != 0
                                                        ? formatTruncate(
                                                            RaceTo17PL2
                                                          )
                                                        : " "}
                                                    </span>
                                                  </div>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </span>
                                      </div>
                                    </h3>

                                    <div class="price-row-box-new">
                                      <div
                                        class={
                                          isSuspended
                                            ? "runner-disabled2 suspendCls"
                                            : "runner-disabled2 suspendCls hides"
                                        }
                                      >
                                        {suspendedText}
                                      </div>
                                      <a class="price-price price-back whtBack">
                                        <div>&nbsp;</div>
                                      </a>

                                      <a class="price-price price-back whtBack">
                                        <div>&nbsp;</div>
                                      </a>

                                      <a
                                        class="price-price price-back mb-show span1details"
                                        id="runner1b1span"
                                        data-bettype="b"
                                        onClick={() =>
                                          showBetfairBetSlip(
                                            "b",
                                            "race to 17",
                                            "race to 17",
                                            b1,
                                            "m",
                                            1,
                                            1
                                          )
                                        }
                                      >
                                        <div id="rnr1" class="sus_cls">
                                          <span
                                            class="price-odd odd"
                                            id="runner1b1"
                                          >
                                            {b1}
                                          </span>
                                          <span class="price-amount" id="rate1">
                                            {stakeLimit}
                                          </span>
                                        </div>
                                      </a>

                                      <a
                                        class="price-price price-lay ml-4 mb-show span1details"
                                        id="runner1l1span"
                                        data-bettype="l"
                                        onClick={() =>
                                          showBetfairBetSlip(
                                            "l",
                                            "race to 17",
                                            "race to 17",
                                            l1,
                                            "m",
                                            1,
                                            1
                                          )
                                        }
                                      >
                                        <div id="rnr11" class="sus_cls">
                                          <span
                                            class="price-odd odd"
                                            id="runner1l1"
                                          >
                                            {l1}
                                          </span>
                                          <span
                                            class="price-amount"
                                            id="rate11"
                                          >
                                            {stakeLimit}
                                          </span>
                                        </div>
                                      </a>

                                      <a class="price-price price-lay whtBack">
                                        <div>&nbsp;</div>
                                      </a>

                                      <a class="price-price price-lay mr-4 whtBack">
                                        <div>&nbsp;</div>
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div
                                style={{
                                  height: "5px",
                                  backgroundColor: "#000"
                                }}
                              ></div>

                              <div
                                class="tb-content"
                                style={{
                                  background: "#fff"
                                }}
                              >
                                <div class="market-titlebar">
                                  <p class="market-name">
                                    <span class="market-name-badge">
                                      <i class="market-name-icon">
                                        <img
                                          src="/assets/images/time-img.png"
                                          style={{
                                            filter: "invert(100%)",
                                            marginTop: "-8px",
                                            marginLeft: "-1px"
                                          }}
                                        />
                                      </i>
                                      <span>Any Zero Card</span>
                                    </span>
                                  </p>
                                  <div class="market-overarround">
                                    <span></span>
                                    <strong>Back</strong>
                                  </div>
                                  <div class="market-overarround market-overarround-lay">
                                    <strong>Lay</strong>
                                  </div>
                                </div>

                                <div class="market-runners">
                                  <div
                                    class={
                                      isAnyZeroWinner == 1 && cardsSettled
                                        ? "runner-runner sussesBg"
                                        : "runner-runner"
                                    }
                                  >
                                    <h3 class="runner-name" id="b1Sucess">
                                      <div class="runner-info">
                                        <span class="clippable runner-display-name">
                                          <table>
                                            <tbody>
                                              <tr>
                                                <td>
                                                  <h4
                                                    style={{
                                                      marginBottom: "0px",
                                                      fontSize: "16px",
                                                      fontWeight: "700"
                                                    }}
                                                    class="clippable-spacer"
                                                  >
                                                    Any Zero Card
                                                  </h4>
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>
                                                  <div
                                                    style={{
                                                      float: "left",
                                                      display:
                                                        AnyZeroCardPL1 != 0
                                                          ? ""
                                                          : "none",
                                                      color:
                                                        AnyZeroCardPL1 > 0
                                                          ? "green"
                                                          : "red"
                                                    }}
                                                  >
                                                    <span
                                                      style={{
                                                        display:
                                                          AnyZeroCardPL1 != 0
                                                            ? ""
                                                            : "none",
                                                        color:
                                                          AnyZeroCardPL1 > 0
                                                            ? "green"
                                                            : "red"
                                                      }}
                                                    >
                                                      {AnyZeroCardPL1 != 0
                                                        ? formatTruncate(
                                                            AnyZeroCardPL1
                                                          ) + "/"
                                                        : " "}{" "}
                                                    </span>

                                                    <span
                                                      style={{
                                                        display:
                                                          AnyZeroCardPL2 != 0
                                                            ? ""
                                                            : "none",
                                                        color:
                                                          AnyZeroCardPL2 > 0
                                                            ? "green"
                                                            : "red"
                                                      }}
                                                    >
                                                      {AnyZeroCardPL2 != 0
                                                        ? formatTruncate(
                                                            AnyZeroCardPL2
                                                          )
                                                        : " "}
                                                    </span>
                                                  </div>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </span>
                                      </div>
                                    </h3>

                                    <div class="price-row-box-new">
                                      <div
                                        class={
                                          anyZeroCardSuspend == 1
                                            ? "runner-disabled2 suspendCls"
                                            : "runner-disabled2 suspendCls hides"
                                        }
                                      >
                                        {suspendedText}
                                      </div>
                                      <a class="price-price price-back whtBack">
                                        <div>&nbsp;</div>
                                      </a>

                                      <a class="price-price price-back whtBack">
                                        <div>&nbsp;</div>
                                      </a>

                                      <a
                                        class="price-price price-back mb-show span1details"
                                        id="runner1b1span"
                                        onClick={() =>
                                          showBetfairBetSlip(
                                            "b",
                                            "any zero card",
                                            "any zero card",
                                            b2,
                                            "m",
                                            1,
                                            2
                                          )
                                        }
                                      >
                                        <div id="rnr1" class="sus_cls">
                                          <span
                                            class="price-odd odd"
                                            id="runner1b1"
                                          >
                                            {b2}
                                          </span>
                                          <span class="price-amount" id="rate1">
                                            {stakeLimit}
                                          </span>
                                        </div>
                                      </a>

                                      <a
                                        class="price-price price-lay ml-4 mb-show span1details"
                                        id="runner1l1span"
                                        data-teamname="Spades"
                                        data-bettype="l"
                                        onClick={() =>
                                          showBetfairBetSlip(
                                            "l",
                                            "any zero card",
                                            "any zero card",
                                            l2,
                                            "m",
                                            1,
                                            2
                                          )
                                        }
                                      >
                                        <div id="rnr11" class="sus_cls">
                                          <span
                                            class="price-odd odd"
                                            id="runner1l1"
                                          >
                                            {l2}
                                          </span>
                                          <span
                                            class="price-amount"
                                            id="rate11"
                                          >
                                            {stakeLimit}
                                          </span>
                                        </div>
                                      </a>

                                      <a class="price-price price-lay whtBack">
                                        <div>&nbsp;</div>
                                      </a>

                                      <a class="price-price price-lay mr-4 whtBack">
                                        <div>&nbsp;</div>
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <span
                                style={{
                                  display: activeTabIndex == 2 ? "" : "none",
                                  opacity: 1
                                }}
                              >
                                <Race17Result />
                              </span>
                            </div>
                          </div>
                        </div>

                        <div
                          style={{
                            display: activeTabIndex == 2 ? "" : "none",
                            color: "white"
                          }}
                        >
                          <Race17Result resultData={resultData} />
                        </div>
                      </div>
                    </div>

                    <div className="col-md-4">
                      {showBetSlipPopup && (
                        <TPPopUpBetSlip
                          closeBetSlipParent={closeBetSlipMobile}
                          betObj={placeBetObject}
                          placeBetParent={placeBet}
                          betButtonShow={betButtonShow}
                          betErrorMessageObj={betErrorMessageObj}
                          betButtonShowLoaderShow={betButtonShowLoaderShow}
                          profileData={profileData}
                        />
                      )}
                      <TeenPattisCasinoBetslipWeb
                        showBetSlip={showBetSlip}
                        placeBetObject={placeBetObject}
                        closeBetSlipParent={closeBetSlip}
                        placeBetParent={placeBet}
                        betErrorMessageObj={betErrorMessageObj}
                        profileData={profileData}
                      ></TeenPattisCasinoBetslipWeb>
                      <div>
                        <div className="bets">
                          <strong>
                            Matched Bets (0)
                            <img
                              src={reconnecting}
                              alt="dc"
                              className="rounded disconnected"
                              style={{ display: "none" }}
                            />{" "}
                          </strong>
                          <div className="betting-table">
                            <table className="table">
                              <thead>
                                <tr>
                                  <th>Runner</th>
                                  <th>Price</th>
                                  <th>Size</th>
                                  <th></th>
                                </tr>
                              </thead>
                              <tbody>
                                {placedBets.map((bet, index) => {
                                  console.log("MATCHED BET:", bet);

                                  return (
                                    <tr
                                      key={index}
                                      style={{
                                        background:
                                          bet.type == "b"
                                            ? "#e9f6fc"
                                            : "#fce3e4"
                                      }}
                                    >
                                      <td>
                                        {displayRunnerName(bet.rnr)} - (
                                        {bet.cat_mid})
                                      </td>

                                      <td>{bet.amnt}</td>
                                      <td>{bet.rate}</td>
                                      <td></td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <style>
            {`
              
                .teenpatti-scope #videos {
                  padding-top: 10px !important;
                }

                .teenpatti-scope .race17-gradient {
                  position: relative;
                  background: #000000;
                  overflow: hidden;
                }

                .teenpatti-scope .race17-gradient::before {
                  content: "";
                  position: absolute;
                  top: 0;
                  right: 0;
                  bottom: 0;
                  left: 0;
                  background: radial-gradient(
                    ellipse 100% 44% at 50% calc(30% + 50px),
                    rgba(62, 193, 65, 0.95) 0%,
                    rgba(62, 193, 65, 0.8) 15%,
                    rgba(30, 80, 35, 0.5) 40%,
                    #1e1e1e 55%,
                    #1e1e1e 100%
                  );
                  opacity: 0.4;
                  pointer-events: none;
                  z-index: 0;
                }

                .teenpatti-scope .race17-gradient > * {
                  position: relative;
                  z-index: 1;
                }

                .teenpatti-scope .cards-layout.blackjack {
                  position: relative;
                  background: #000000;
                }

                .teenpatti-scope .cards-layout.blackjack::before {
                  content: "";
                  position: absolute;
                  top: 0;
                  right: 0;
                  bottom: 0;
                  left: 0;
                  background: radial-gradient(
                    ellipse 100% 44% at 50% calc(30% + 50px),
                    rgba(62, 193, 65, 0.95) 0%,
                    rgba(62, 193, 65, 0.8) 15%,
                    rgba(30, 80, 35, 0.5) 40%,
                    #1e1e1e 55%,
                    #1e1e1e 100%
                  );
                  opacity: 0.4;
                  pointer-events: none;
                  z-index: 0;
                }

                .teenpatti-scope .cards-layout.blackjack > * {
                  position: relative;
                  z-index: 1;
                }

                .teenpatti-scope .race17-timer-row {
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  padding: 0 12px;
                  position: relative;
                  z-index: 2;
                }

                .teenpatti-scope .race17-timer-row .Connectedclients {
                  position: relative;
                  top: -15px;
                  margin: 0;
                  opacity: 0.9;
                  z-index: 2;
                  float: none;
                  width: auto;
                  display: inline-flex;
                  align-items: center;
                }

                .teenpatti-scope .race17-timer-row .teenpatti-base-timer {
                  position: relative;
                  top: -5px;
                  right: -4px;
                  margin-left: auto;
                }

                .teenpatti-scope .race17-gradient .sound-icon {
                  transform: scale(0.8);
                  transform-origin: center;
                }

                .player {
                  margin: 4px;
                  display: inline-block;
                  justify-content: space-between;
                  flex: 1 0 0;
                  flex-wrap: wrap;
              }

              .player-item {
                margin-top: 0 !important;
                margin-bottom: 20px;
                display: block;
                margin-right: 0;
                z-index: 0;
            }
                .teenpatti-scope.player-scope .player-item .name {
                    display: block;
                    color: #d7bc7b;
                    font-size: 12px;
                    font-weight: 700;
                    padding-bottom: 5px;
                    text-align: center;
                }
                .player-item .player-card {
                    border-radius: 12px;
                    border: 1px solid rgba(178, 220, 175, .25);
                }
                .BFBCardHandView {
                  transform: translate3d(0, 0, 0);
                  /* width: 220px; */
                  width: 100%;
                  height: 50px;
                  margin-top: 5px;
                  margin-bottom: 5px;
              }
                 
                .BFBCardFanView{
                    padding:0px;
                }
                .player-scope .player-card {
                  border: 1px solid rgba(173, 172, 172, 0.5);
                  justify-content: center;
                  width: 97%;
                  height: auto;
                  border-radius: 20px;
                  padding: 2px;
                  background: transparent;
              }
              .card1 {
                transform: perspective(430px) translateZ(0) rotateZ(0deg) rotateY(0deg);
                width: 40px;
                height: 50px;
                transform-origin: 50% 100%;
                margin-left: 5px;
                float: left;
            }

            .player-scope .table-player .player {
              width: 210px !important;
            }
            .row{
              padding-left: 3px;
            }
            .player-scope .table-player {
              gap: 9px !important;
              align-items: center;
              display: flex;
              flex-direction: column;
              justify-content: flex-start;
              height: auto !important;
              min-height: auto !important;
            }
            .player-scope .table-player .player-dt {
              display: flex !important;
              flex-direction: column;
              align-items: center !important;
              max-width: none;
              width: auto;
              color: #d7bc7b !important;
              font-size: 12px;
              font-weight: 700;
            }
            @media (min-width: 768px) {
              .left-content center,
              .left-content .bg-white {
                margin-left: 10px;
              }
            }
            @media (min-width:992px){
              .cards-layout.blackjack {
                min-height: 240px;
              }
              .volume-wrapper {
                margin-top: -30px;
              }
            }  
            /* mobile */  
            @media (max-width:576px){
              .cards-layout.blackjack {
                min-height: 120px !important;
              }
              .player-scope .table-player .player {
                width: 170px !important;
                height: 70px !important;
              }
              .titlebarname p{
                font-size: 14px;
              }
              .cards-layout.blackjack .col-12{
                padding-left:0;
                padding-right:0;
              }
              .tp-card img{
                height: 55px;   
                width: auto;
                border-radius: 3px;
              }
              .row{
              padding-left: 0px;
              }
              .player-item {
                margin-top: 0 !important;
              }
              .player-card{
                width: 92% !important;
                height: 100px !important;
              }
              .col-md-4,
              .space{
                margin-top: 6px;
              }
              
            }  
            
            .player-card {
                height: 70px !important;
            }   
            .tp-card {
              top: 24px !important;  
            } 
            .video-button{
              height: 35px !important;
              width: 40px !important;
              border:0px
            }
                  @media (max-width: 768px) {
        .buttons-div {
    display: flex;
    gap: 2px; 
}
            }
                `}
          </style>
        </div>
      </ClientLayoutWithOutHeader>
    </div>
  );
}
